module.exports = __webpack_public_path__ + "static/media/banner-kuaima.9497dd3b.png";